import { FC } from 'react';
import { theme } from '../constants';
import { InputHTMLAttributes } from 'react'; // 👈 1. Import InputHTMLAttributes

// 2. Extend the standard HTML Input attributes for <input>
type Props = InputHTMLAttributes<HTMLInputElement> & {
  
    clickable?: boolean;
    containerStyle?: object;
    label?: string;
    icon?: JSX.Element;
    
    // We can redefine these to be more specific if needed, 
    // but the inherited types are usually sufficient:
    type?: 'text' | 'password'; 
    autoCapitalize?: 'none' | 'sentences' | 'words' | 'characters';
    
    // Removing 'value' and 'onChange' from the list below is cleaner, 
    // as they are covered by InputHTMLAttributes.
};

export const InputField: FC<Props> = ({
    placeholder,
    containerStyle,
    autoCapitalize = 'none',
    label,
    icon,
    clickable,
    type = 'text',
    value,
    onChange,
    // Add style here if you want to handle it separately from {...rest},
    // but it's best to keep it in {...rest}
    ...rest // This now safely contains readOnly, style, and any other valid input prop
}) => {
    return (
        <div
      style={{
        height: 50,
        paddingLeft: 30,
        paddingRight: 20,
        borderRadius: 12,
        flexDirection: 'row',
        alignItems: 'center',
        position: 'relative',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#e8eff4',
        display: 'flex',
        ...containerStyle,
      }}
    >
           {label && (
        <div
          style={{
            position: 'absolute',
            top: -8,
            left: 20,
            paddingLeft: 10,
            paddingRight: 10,
            borderRadius: 12,
            backgroundColor: '#fff',
            fontSize: 12,
            color: theme.colors.textColor,
            textTransform: 'uppercase',
            fontFamily: 'Mulish-SemiBold',
          }}
        >
          {label}
        </div>
      )}

            <input
                className="input-field"
                // Standard props that you want to handle or override directly
                autoCapitalize={autoCapitalize}
                placeholder={placeholder}
                maxLength={50}
                type={type}
                value={value ?? ''}
                onChange={onChange}
                
                // ... (your input style)
                  style={{
          width: '100%',
          height: '100%',
          padding: 0,
          margin: 0,
          border: 'none',
          outline: 'none',
          backgroundColor: 'transparent',
          fontSize: 16,
          color: theme.colors.mainColor,
         
        }}
                
                {...rest} 
            />

                {/* Show icon */}
      {icon && !clickable && <div>{icon}</div>}
      {icon && clickable && (
        <button
          type="button"
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          {icon}
        </button>
      )}


        </div>
    );
};